module.exports = __webpack_public_path__ + "media/npc_dota_hero_keeper_of_the_light.347c2db0.webm";